module.exports = __webpack_public_path__ + "img/reciveOrder.01a75b89.png";